<mat-card appearance="outlined" class="example-card">
	<mat-card-subtitle>Help Text</mat-card-subtitle>

	<mat-card-content>
		<div [innerHTML]="data.HELP_TEXT ">
		</div>
	</mat-card-content>
	<mat-divider inset></mat-divider>

	<mat-card-actions style="text-align: right;">
		Edit Help disabled due to vulnerability
	</mat-card-actions>

	<mat-card-footer style="text-align: center;">
		<a> {{data.CREATED_BY}} : {{data.CREATED_DATE | longDateTime}}
		</a>
		<br>
		<div *ngIf="data.MODIFIED_BY!=null">
			Edited By <a> {{ data.MODIFIED_BY }} : {{data.MODIFIED_DATE | longDateTime }}
			</a>
		</div>
		View History
	</mat-card-footer>
</mat-card>